<template>
<div class="data-monitor-info">
	  <div class="headCarName">
		 <i class="el-icon-setting"></i>&nbsp;&nbsp;详情
		 <div class="headcarBtn" style="float: right;padding-right: 15px;">
			 <el-button class="filter-item" type="info" plain round @click="showDataMonitor">
			   返回上一页
			 </el-button>
		 </div>
	  </div>
	  <!-- 主内容模块 -->
	  <div class="span12" style="margin-top:20px;">
		  <el-row>
		    <el-col :span="12"><div class="grid-content bg-purple">
		  		<label class="col-sm-2 control-label" style="line-height:33px;font-size:20px;float:left;color: #ff5e14;">当前时间：{{myInfoTime}}</label>
		  		</div></el-col>
		    <el-col :span="12"><div class="grid-content bg-purple-light">
					<label class="col-sm-2 control-label" style="line-height:33px;font-size:20px;float:left;color: #ff5e14;">当前车辆：{{myInfocarId}}</label>
		  		</div></el-col>
		 
		  </el-row>
	  </div>
	  
	  <!-- 数据列表区 -->
	 
			  <el-table
			    :data="listData"
			    v-loading="listLoading"
			    border
			    highlight-current-row
			    style="width: 100%;align: center;">
			  
			    <el-table-column prop="carIdStr" label="车辆ID" width="200" align="center">
			    </el-table-column>
			    <el-table-column prop="carName" label="车辆名称" align="center">
			    </el-table-column>
			    <el-table-column prop="carStatus" label="车辆状态" align="center">
			    </el-table-column>
				<el-table-column prop="creatTime" label="记录时间" width="200" align="center">
				</el-table-column>
			    <el-table-column prop="carPower" label="电量"  align="center">
			    </el-table-column>
			    <el-table-column prop="carVol" label="电压" align="center">
			    </el-table-column>
			    <el-table-column prop="carEle" label="电流" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt1" label="超声波(前-左)" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt2" label="超声波(前-右)" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt3" label="超声波(后-左)" align="center">
			    </el-table-column>
			    <el-table-column prop="carUlt4" label="超声波(后-右)" align="center">
			    </el-table-column>
				<el-table-column prop="carUlt5" label="超声波(左-上)" align="center">
				</el-table-column>
				<el-table-column prop="carUlt6" label="超声波(左-下)" align="center">
				</el-table-column>
				<el-table-column prop="carUlt7" label="超声波(右-上)" align="center">
				</el-table-column>
				<el-table-column prop="carUlt8" label="超声波(右-下)" align="center">
				</el-table-column>
				<el-table-column prop="carErrorCode" label="故障码" align="center">
				</el-table-column>
			  </el-table>
			  
			 <!-- 分页栏 -->
			 <pagination :total="totalCounts"
			   @pagination="handlePageChange">
			 </pagination>
			
  
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import {dataMonitorDataDetailList} from '@/api/car'

export default{
	name: 'DataMonitorInfo',
	components: {
	  Pagination
	},
	data(){
		  return{
			  listLoading:true,
			  totalCounts: 0,
			  listData:[],
			  myInfocarId:localStorage.getItem('monitorInfoCarId'),
			  myInfoTime:localStorage.getItem('monitorInfoTime'),
			  listQuery: {
			    carId: localStorage.getItem('monitorInfoCarId'),
				currentTime:localStorage.getItem('monitorInfoTime'),
			    pageIndex: 1,
			    pageSize: 10,
			  },
		  }
	},
	methods:{
		/**
		 * handleFilter 用于请求车辆数据
		 */
		handleFilter() {
		  this.listLoading = true
		  dataMonitorDataDetailList(this.listQuery).then(res => {
		    let data = res.pageData
		    this.totalCounts = data.totalCounts
		    // 对后端数据进行解析
		    this.listData = data.datas.map(item => {
				let statusName='';
				if(item.status===0){
					statusName='正常';
				}else if(item.status===1){
					statusName='未接入';
				}else if(item.status===2){
					statusName='故障';
				}
		      return {
		        carIdStr:item.carId,
		        carName:item.name,
		        carStatus:statusName,
		        creatTime:this.dateFormat("YYYY-mm-dd HH:MM:SS", item.createTime),
		        carPower:item.electric,
		        carVol:item.voltage,
		        carEle:item.powerLeft,
		        carUlt1:item.ultrasonic1,
		        carUlt2:item.ultrasonic2,
		        carUlt3:item.ultrasonic3,
		        carUlt4:item.ultrasonic4,
		        carUlt5:item.ultrasonic5,
		        carUlt6:item.ultrasonic6,
		        carUlt7:item.ultrasonic7,
		        carUlt8:item.ultrasonic8,
		        carErrorCode:item.troubleCode,
		      }
		    })
		    this.listLoading = false;
		  })
		},
		handlePageChange(data) {
		  this.listQuery.pageIndex = data.page
		  this.listQuery.pageSize = data.limit
		  this.handleFilter()
		},
		/**
		 * 日期格式化
		 * @param {Object} fmt 
		 * @param {Object} date
		 */
		dateFormat(fmt, date){
		  let ret;
		  date=new Date(date);
		  	    const opt = {
		  	        "Y+": date.getFullYear().toString(),        // 年
		  	        "m+": (date.getMonth() + 1).toString(),     // 月
		  	        "d+": date.getDate().toString(),            // 日
		  	        "H+": date.getHours().toString(),           // 时
		  	        "M+": date.getMinutes().toString(),         // 分
		  	        "S+": date.getSeconds().toString()          // 秒
		  	        // 有其他格式化字符需求可以继续添加，必须转化成字符串
		  	    };
		  	    for (let k in opt) {
		  	        ret = new RegExp("(" + k + ")").exec(fmt);
		  	        if (ret) {
		  	            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		  	        };
		  	    };
		  	    return fmt;
		},
		/**
		 * 返回上一页
		 */
		showDataMonitor(){
			this.$router.push({  
				name:'data_monitor',
		    });
			localStorage.setItem('monitorCarId',this.myInfocarId)	
		}
	},
	mounted() {
	  this.handleFilter()
	},
}
</script>

<style>
	.headCarName{
		background-color:#3fb976;
		width:100%;
		height:50px;
		color:#FFFFFF;
		line-height:50px;
		padding-left: 15px;
		border-radius: 10px;
	}
</style>
